export default __webpack_public_path__ + "static/media/facility_01_5.7189a93b.png";